import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {GenderFuncService} from '../../../../../core/services/genderFunc.service';

@Component({
    selector: 'add-connection',
    templateUrl: './addConnection.html',
    styleUrls: ['./addConnection.scss'],
    standalone: false
})

export class AddConnection implements OnInit {

  genderTypes;
  userName = '';
  userType: any;
  userTypeId = '';
  chosenType = '';
  countType = 'one';
  currentUserName = '';

  userAccountType;

  users;
  usersType: any = {};
  constructor(public dialogRef: MatDialogRef<AddConnection> ,
              @Inject(MAT_DIALOG_DATA) private data: any, public genderService: GenderFuncService) {
    if (data && data.countType === 'one') {
      this.userName = data.userName;
      this.userTypeId = data.type;
      this.countType = 'one';
      this.currentUserName = data.currentUserName;
    } else if (data && data.countType === 'many') {
      this.users = data.users;
      this.userName = data.userName;
      this.countType = 'many';
    }
    if (data && data.userType) {
      this.userAccountType = data.userType;
    }
  }

  ngOnInit() {
    this.getGenders();
  }

  getGenders() {
    this.genderService.findAvailable().subscribe((res: any) => {
      if (res) {
        if (this.userTypeId) {
          this.userType = res.find(el => +el.id === +this.userTypeId);
          if (this.userType) {
            if (this.userType.isAdult) {
              res = res.filter(el => el.isChild);
            } else if (this.userType.isChild) {
              res = res.filter(el => el.isAdult && !el.onlyForAdult);
            } else  {
              if (this.userAccountType === 'parent') {
                res = res.filter(el => !el.isAdult && !el.isChild);
              } else {
                res = res.filter(el => !el.isAdult && !el.isChild && !el.onlyForAdult);
              }
            }
          }
        }
        this.genderTypes = res;
        if (this.users && this.users.length) {
          this.users.forEach(el => {
            if (el.gender === 'male') {
              let brother = this.genderTypes.find(gt => gt.defaultType === 'brother');
              el.genderTypeId = brother.id;
              this.usersType[el.id] = brother;
            } else
            if (el.gender === 'female') {
              let sister = this.genderTypes.find(gt => gt.defaultType === 'sister');
              el.genderTypeId = sister.id;
              this.usersType[el.id] = sister;
            } else {
              this.usersType[el.id] = 0;
            }
          });
        }
      }
    });
  }

  saveConnection() {
    if (this.countType === 'one') {
      this.dialogRef.close(this.chosenType);
    } else {
      this.dialogRef.close(this.usersType);
    }
  }

  checkBeforeClose() {
    if (this.countType === 'one') {
      this.dialogRef.close();
    }else {
      this.dialogRef.close(this.usersType);
    }
  }

  changeType(event, userId) {
    let genderType = this.genderTypes.find(gt => +gt.id === +event);
    this.usersType[userId] = genderType;
  }
}
